export default __webpack_public_path__ + "static/media/sch6.eabde7c8.jpg";